import React, { useState } from 'react';

import { ResultImage, ResultItemProps, useHawksearch, TrackingEvent } from 'react-hawksearch';

function FeatureItem({ item, bannerId, campaignId }: ResultItemProps) {
	const {
		store: { searchResults },
	} = useHawksearch();
	const price = parseFloat(item.getDocumentValue('price') || '');
	const imageURL = item.getDocumentValue('image') || '';

	const nameValue = item.getDocumentValue('name') || '';
	const pageURL = item.getDocumentValue('url_detail') || '';
	const sku = item.getDocumentValue('sku') || '';
	const bestFragment = item.BestFragment || '';
	const contentTypeValue = item.getDocumentValue('content_type') || '';
	const itemType = item.getDocumentValue('itemtype');
	const descriptionShort = item.getDocumentValue('description_short');
	function trackEvent(type: string) {
		if (searchResults && searchResults.TrackingId) {
			TrackingEvent.track('bannerclick', {
				bannerId,
				campaignId,
				trackingId: searchResults.TrackingId,
			});
		}
	}
	function onImageLoad() {
		trackEvent('bannerimpression');
	}
	function trackClickEvent(e, url = '') {
		TrackingEvent.track('click', {
			event: e,
			uniqueId: item.DocId,
			trackingId: localStorage.getItem('tracking-id'),
			url,
		});
	}
	return (
		<div className="hawk-preview__featured-items__item" onClick={() => trackEvent('bannerclick')}>
			<ResultImage item={item} onLoadCallBack={onImageLoad} imageUrl={imageURL} imageTitle={nameValue} />
			<div className="hawk-preview__featured-items__item-name">
				<div>{item.getDocumentValue('sku') || ''}</div>
				<div className="hawk-results__item-name">{item.getDocumentValue('name') || ''}</div>
				<a onClick={e => trackClickEvent(e, pageURL)} href="{{pageURL}}" className="more">
					View Details
				</a>
			</div>
		</div>
	);
}

export default FeatureItem;
